var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfigSelectedWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #e11e24;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1712",
    "data-name": "Group 1712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add_box_FILL0_wght400_GRAD0_opsz48",
    "data-name": "add box FILL0 wght400 GRAD0 opsz48",
    className: "cls-2",
    d: "M1.1,12.8c-.6,0-1.1-.5-1.1-1.1V1.1C0,.5.5,0,1.1,0h10.7c.6,0,1.1.5,1.1,1.1v10.7c0,.6-.5,1.1-1.1,1.1H1.1ZM1.1,11.8h10.7V1.1H1.1v10.7ZM1.1,11.8h0V1.1h0v10.7Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    className: "cls-1",
    x1: 6.5,
    y1: 2.9,
    x2: 6.5,
    y2: 9.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    className: "cls-1",
    x1: 10,
    y1: 6.4,
    x2: 3,
    y2: 6.4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigSelectedWhite);
export default __webpack_public_path__ + "static/media/config-selected-white.c79b1161d6bc530406897ee1c0e3510b.svg";
export { ForwardRef as ReactComponent };